import * as S from './styles';

const DotLoading = (): JSX.Element => <S.Dot role="status" />;

export default DotLoading;
